import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Bạn có chắc chắn mình không sử dụng Ngân Hàng/ATM/Mobile Banking/Momo/App Banking,...?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-20" }, "Nạp bằng thẻ cào sẽ bị khấu trừ chiết khấu lên tới 30% (Tức là nạp thẻ 100k có thể chỉ nhận được 70k)", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Nếu bạn là một người chơi ở nước ngoài (hiện không ở Việt Nam), hãy liên hệ Fanpage/Admin để nhận trợ giúp về ["),
  /*#__PURE__*/_createElementVNode("strong", null, "Nạp tiền tại nước ngoài"),
  /*#__PURE__*/_createTextVNode("]")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_info_circle_outlined = _resolveComponent("info-circle-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.chargeViaCard')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: !_ctx.isReady,
        active: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_alert, {
            type: "error",
            message: "Cảnh báo!!!",
            "show-icon": "",
            class: "mb-20"
          }, {
            description: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          }),
          (!_ctx.isValidClientAddress)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 0,
                type: "warning",
                message: "Bạn không có quyền truy cập trang này",
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_form, {
                key: 1,
                ref: "form",
                model: _ctx.formModel,
                onFinish: _ctx.onFinish,
                layout: 'vertical',
                rules: _ctx.formRule,
                scrollToFirstError: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.charge_card_type'),
                    name: "type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.formModel.type,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModel.type) = $event)),
                        options: Object.keys(_ctx.cardOptions?.list || {}).map(key => {
                            return {
                                value: key,
                                label: _ctx.cardOptions?.list[key],
                                disabled: _ctx.cardOptions?.disabled?.includes(key),
                            };
                        })
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.charge_card_price'),
                    name: "price"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.formModel.price,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.price) = $event)),
                        "show-search": "",
                        options: [10000, 20000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000].map(v => {
                            return {
                                value: v,
                                label: _ctx.number_format(v),
                            };
                        })
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.charge_card_serial'),
                    name: "serial"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formModel.serial,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModel.serial) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.charge_card_code'),
                    name: "code"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formModel.code,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModel.code) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        loading: _ctx.isLoading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.charge')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish", "rules"]))
        ]),
        _: 1
      }, 8, ["loading"]),
      (_ctx.hasManagerPermission)
        ? (_openBlock(), _createBlock(_component_a_table, {
            key: 0,
            dataSource: _ctx.dataSource,
            columns: _ctx.columns,
            pagination: _ctx.pagination,
            loading: _ctx.isLoadingTable,
            scroll: {x: '100%'}
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.key === 'action')
                ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                    default: _withCtx(() => [
                      (record.status !== _ctx.PaymentStatus.COMPLETED)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 0,
                            title: "Xem thông tin giao dịch"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                size: "small",
                                onClick: ($event: any) => (_ctx.checkPaymentConfirm(record))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_info_circle_outlined)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (record.status === _ctx.PaymentStatus.PROCESSING)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 1,
                            title: "Huỷ giao dịch"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                danger: "",
                                size: "small",
                                onClick: ($event: any) => (_ctx.deletePaymentConfirm(record))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_DeleteOutlined)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["dataSource", "columns", "pagination", "loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}